<template>
<VMain>
  <VContainer>
    <my-business-wrapper/>
    <h2 class="mb-5">Pending History</h2>
    <pending-history />
  </VContainer>
</VMain>
  
</template>

<script>
import myBusinessWrapper from '@/components/Businesses/my-business-wrapper'
import pendingHistory from '@/components/Businesses/Pending/pendingHistory';
export default {
    components:{
        pendingHistory,
        myBusinessWrapper
    }

}
</script>

<style>

</style>